/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Uppbeat.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CustomerSubPlanItem,
  GetApiV1UsersParams,
  GetApiV1UsersUserIdArtistDownloadStatsParams,
  GetApiV1UsersUserIdCarouselsJumpBackInParams,
  GetApiV1UsersUserIdCarouselsRecentDownloadsParams,
  GetApiV1UsersUserIdCustomerSubPlansParams,
  GetApiV1UsersUserIdMetaEventLogsParams,
  GetApiV1UsersUserIdMgUsageLogsParams,
  GetApiV1UsersUserIdMusicUsageLogsParams,
  GetApiV1UsersUserIdSfxUsageLogsParams,
  GetApiV1UsersUserIdVideoUsageLogsParams,
  GetUserArtistDownloadStatsResponse,
  GetUserCustomerSubPlansResponse,
  GetUserJumpBackInCarouselResponse,
  GetUserListResponse,
  GetUserMetaEventLogsResponse,
  GetUserMgUsageLogsResponse,
  GetUserMusicUsageLogsResponse,
  GetUserPermissionsResponse,
  GetUserPreferenceResponse,
  GetUserRecentDownloadsCarouselResponse,
  GetUserResponse,
  GetUserSfxUsageLogsResponse,
  GetUserVideoUsageLogsResponse,
  HttpValidationProblemDetails,
  PatchUserPreferenceRequestBody,
  PatchUserRequestBody,
  PostApiV1UsersHeaders,
  PostApiV1UsersUserIdPermissionOverridesPermissionIdParams,
  PostUserLicenseCodeResponse,
  PostUserPreferenceRequestBody,
  PostUserPreferenceResponse,
  PostUserRegistrationRequestBody,
  PostUserRegistrationResponse,
  ProblemDetails,
  PutUserConversionReasonRequestBody,
  PutUserEmailRequestBody,
  PutUserHearAboutUsRequestBody,
  PutUserPreferenceRequestBody,
  PutUserRegistrationQuestionAnswerRequestBody,
  ValidateAccountDeletionCodeResponse
} from '../model';

import { apiClient } from '../../lib/api-client';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const postApiV1Users = (
    postUserRegistrationRequestBodyNull: PostUserRegistrationRequestBody | null,
    headers?: PostApiV1UsersHeaders,
 signal?: AbortSignal
) => {


      return apiClient<PostUserRegistrationResponse | null>(
      {url: `/api/v1/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', ...headers},
      data: postUserRegistrationRequestBodyNull, signal
    },
      );
    }




export const getPostApiV1UsersMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1Users>>, TError,{data: PostUserRegistrationRequestBody | null;headers?: PostApiV1UsersHeaders}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1Users>>, TError,{data: PostUserRegistrationRequestBody | null;headers?: PostApiV1UsersHeaders}, TContext> => {

const mutationKey = ['postApiV1Users'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1Users>>, {data: PostUserRegistrationRequestBody | null;headers?: PostApiV1UsersHeaders}> = (props) => {
          const {data,headers} = props ?? {};

          return  postApiV1Users(data,headers,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1UsersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1Users>>>
    export type PostApiV1UsersMutationBody = PostUserRegistrationRequestBody | null
    export type PostApiV1UsersMutationError = ProblemDetails | null

    export const usePostApiV1Users = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1Users>>, TError,{data: PostUserRegistrationRequestBody | null;headers?: PostApiV1UsersHeaders}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1Users>>,
        TError,
        {data: PostUserRegistrationRequestBody | null;headers?: PostApiV1UsersHeaders},
        TContext
      > => {
      return useMutation(getPostApiV1UsersMutationOptions(options), queryClient);
    }
    export const getApiV1Users = (
    params: GetApiV1UsersParams,
 signal?: AbortSignal
) => {


      return apiClient<GetUserListResponse | null>(
      {url: `/api/v1/users`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1UsersQueryKey = (params?: GetApiV1UsersParams,) => {
    return [
    `/api/v1/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1UsersQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1Users>>, TError = ProblemDetails | null>(params: GetApiV1UsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Users>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1UsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1Users>>> = ({ signal }) => getApiV1Users(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1Users>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1UsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1Users>>>
export type GetApiV1UsersQueryError = ProblemDetails | null


export function useGetApiV1Users<TData = Awaited<ReturnType<typeof getApiV1Users>>, TError = ProblemDetails | null>(
 params: GetApiV1UsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Users>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Users>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Users>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Users<TData = Awaited<ReturnType<typeof getApiV1Users>>, TError = ProblemDetails | null>(
 params: GetApiV1UsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Users>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Users>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Users>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Users<TData = Awaited<ReturnType<typeof getApiV1Users>>, TError = ProblemDetails | null>(
 params: GetApiV1UsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Users>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1Users<TData = Awaited<ReturnType<typeof getApiV1Users>>, TError = ProblemDetails | null>(
 params: GetApiV1UsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Users>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1UsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1UsersUserIdPreference = (
    userId: number,
 signal?: AbortSignal
) => {


      return apiClient<GetUserPreferenceResponse | null>(
      {url: `/api/v1/users/${userId}/preference`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1UsersUserIdPreferenceQueryKey = (userId: number,) => {
    return [
    `/api/v1/users/${userId}/preference`
    ] as const;
    }


export const getGetApiV1UsersUserIdPreferenceQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1UsersUserIdPreference>>, TError = ProblemDetails | null>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdPreference>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1UsersUserIdPreferenceQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1UsersUserIdPreference>>> = ({ signal }) => getApiV1UsersUserIdPreference(userId, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdPreference>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1UsersUserIdPreferenceQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1UsersUserIdPreference>>>
export type GetApiV1UsersUserIdPreferenceQueryError = ProblemDetails | null


export function useGetApiV1UsersUserIdPreference<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdPreference>>, TError = ProblemDetails | null>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdPreference>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdPreference>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdPreference>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdPreference<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdPreference>>, TError = ProblemDetails | null>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdPreference>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdPreference>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdPreference>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdPreference<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdPreference>>, TError = ProblemDetails | null>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdPreference>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1UsersUserIdPreference<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdPreference>>, TError = ProblemDetails | null>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdPreference>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1UsersUserIdPreferenceQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiV1UsersUserIdPreference = (
    userId: number,
    postUserPreferenceRequestBodyNull: PostUserPreferenceRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<PostUserPreferenceResponse | null>(
      {url: `/api/v1/users/${userId}/preference`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserPreferenceRequestBodyNull, signal
    },
      );
    }




export const getPostApiV1UsersUserIdPreferenceMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UsersUserIdPreference>>, TError,{userId: number;data: PostUserPreferenceRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1UsersUserIdPreference>>, TError,{userId: number;data: PostUserPreferenceRequestBody | null}, TContext> => {

const mutationKey = ['postApiV1UsersUserIdPreference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1UsersUserIdPreference>>, {userId: number;data: PostUserPreferenceRequestBody | null}> = (props) => {
          const {userId,data} = props ?? {};

          return  postApiV1UsersUserIdPreference(userId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1UsersUserIdPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1UsersUserIdPreference>>>
    export type PostApiV1UsersUserIdPreferenceMutationBody = PostUserPreferenceRequestBody | null
    export type PostApiV1UsersUserIdPreferenceMutationError = ProblemDetails | null

    export const usePostApiV1UsersUserIdPreference = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UsersUserIdPreference>>, TError,{userId: number;data: PostUserPreferenceRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1UsersUserIdPreference>>,
        TError,
        {userId: number;data: PostUserPreferenceRequestBody | null},
        TContext
      > => {
      return useMutation(getPostApiV1UsersUserIdPreferenceMutationOptions(options), queryClient);
    }
    export const putApiV1UsersUserIdPreference = (
    userId: number,
    putUserPreferenceRequestBodyNull: PutUserPreferenceRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/users/${userId}/preference`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserPreferenceRequestBodyNull, signal
    },
      );
    }




export const getPutApiV1UsersUserIdPreferenceMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1UsersUserIdPreference>>, TError,{userId: number;data: PutUserPreferenceRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1UsersUserIdPreference>>, TError,{userId: number;data: PutUserPreferenceRequestBody | null}, TContext> => {

const mutationKey = ['putApiV1UsersUserIdPreference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1UsersUserIdPreference>>, {userId: number;data: PutUserPreferenceRequestBody | null}> = (props) => {
          const {userId,data} = props ?? {};

          return  putApiV1UsersUserIdPreference(userId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1UsersUserIdPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1UsersUserIdPreference>>>
    export type PutApiV1UsersUserIdPreferenceMutationBody = PutUserPreferenceRequestBody | null
    export type PutApiV1UsersUserIdPreferenceMutationError = ProblemDetails | null

    export const usePutApiV1UsersUserIdPreference = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1UsersUserIdPreference>>, TError,{userId: number;data: PutUserPreferenceRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1UsersUserIdPreference>>,
        TError,
        {userId: number;data: PutUserPreferenceRequestBody | null},
        TContext
      > => {
      return useMutation(getPutApiV1UsersUserIdPreferenceMutationOptions(options), queryClient);
    }
    export const patchApiV1UsersUserIdPreference = (
    userId: number,
    patchUserPreferenceRequestBodyNull: PatchUserPreferenceRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/users/${userId}/preference`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchUserPreferenceRequestBodyNull, signal
    },
      );
    }




export const getPatchApiV1UsersUserIdPreferenceMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1UsersUserIdPreference>>, TError,{userId: number;data: PatchUserPreferenceRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiV1UsersUserIdPreference>>, TError,{userId: number;data: PatchUserPreferenceRequestBody | null}, TContext> => {

const mutationKey = ['patchApiV1UsersUserIdPreference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiV1UsersUserIdPreference>>, {userId: number;data: PatchUserPreferenceRequestBody | null}> = (props) => {
          const {userId,data} = props ?? {};

          return  patchApiV1UsersUserIdPreference(userId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiV1UsersUserIdPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1UsersUserIdPreference>>>
    export type PatchApiV1UsersUserIdPreferenceMutationBody = PatchUserPreferenceRequestBody | null
    export type PatchApiV1UsersUserIdPreferenceMutationError = ProblemDetails | null

    export const usePatchApiV1UsersUserIdPreference = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1UsersUserIdPreference>>, TError,{userId: number;data: PatchUserPreferenceRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiV1UsersUserIdPreference>>,
        TError,
        {userId: number;data: PatchUserPreferenceRequestBody | null},
        TContext
      > => {
      return useMutation(getPatchApiV1UsersUserIdPreferenceMutationOptions(options), queryClient);
    }
    export const deleteApiV1UsersUserIdPreference = (
    userId: number,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/users/${userId}/preference`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiV1UsersUserIdPreferenceMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1UsersUserIdPreference>>, TError,{userId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1UsersUserIdPreference>>, TError,{userId: number}, TContext> => {

const mutationKey = ['deleteApiV1UsersUserIdPreference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiV1UsersUserIdPreference>>, {userId: number}> = (props) => {
          const {userId} = props ?? {};

          return  deleteApiV1UsersUserIdPreference(userId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiV1UsersUserIdPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1UsersUserIdPreference>>>

    export type DeleteApiV1UsersUserIdPreferenceMutationError = ProblemDetails | null

    export const useDeleteApiV1UsersUserIdPreference = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1UsersUserIdPreference>>, TError,{userId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiV1UsersUserIdPreference>>,
        TError,
        {userId: number},
        TContext
      > => {
      return useMutation(getDeleteApiV1UsersUserIdPreferenceMutationOptions(options), queryClient);
    }
    export const putApiV1UsersUserIdHearAboutUs = (
    userId: number,
    putUserHearAboutUsRequestBodyNull: PutUserHearAboutUsRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/users/${userId}/hear-about-us`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserHearAboutUsRequestBodyNull, signal
    },
      );
    }




export const getPutApiV1UsersUserIdHearAboutUsMutationOptions = <TError = HttpValidationProblemDetails | null | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1UsersUserIdHearAboutUs>>, TError,{userId: number;data: PutUserHearAboutUsRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1UsersUserIdHearAboutUs>>, TError,{userId: number;data: PutUserHearAboutUsRequestBody | null}, TContext> => {

const mutationKey = ['putApiV1UsersUserIdHearAboutUs'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1UsersUserIdHearAboutUs>>, {userId: number;data: PutUserHearAboutUsRequestBody | null}> = (props) => {
          const {userId,data} = props ?? {};

          return  putApiV1UsersUserIdHearAboutUs(userId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1UsersUserIdHearAboutUsMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1UsersUserIdHearAboutUs>>>
    export type PutApiV1UsersUserIdHearAboutUsMutationBody = PutUserHearAboutUsRequestBody | null
    export type PutApiV1UsersUserIdHearAboutUsMutationError = HttpValidationProblemDetails | null | ProblemDetails

    export const usePutApiV1UsersUserIdHearAboutUs = <TError = HttpValidationProblemDetails | null | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1UsersUserIdHearAboutUs>>, TError,{userId: number;data: PutUserHearAboutUsRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1UsersUserIdHearAboutUs>>,
        TError,
        {userId: number;data: PutUserHearAboutUsRequestBody | null},
        TContext
      > => {
      return useMutation(getPutApiV1UsersUserIdHearAboutUsMutationOptions(options), queryClient);
    }
    export const putApiV1UsersUserIdConversionReason = (
    userId: number,
    putUserConversionReasonRequestBodyNull: PutUserConversionReasonRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/users/${userId}/conversion-reason`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserConversionReasonRequestBodyNull, signal
    },
      );
    }




export const getPutApiV1UsersUserIdConversionReasonMutationOptions = <TError = HttpValidationProblemDetails | null | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1UsersUserIdConversionReason>>, TError,{userId: number;data: PutUserConversionReasonRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1UsersUserIdConversionReason>>, TError,{userId: number;data: PutUserConversionReasonRequestBody | null}, TContext> => {

const mutationKey = ['putApiV1UsersUserIdConversionReason'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1UsersUserIdConversionReason>>, {userId: number;data: PutUserConversionReasonRequestBody | null}> = (props) => {
          const {userId,data} = props ?? {};

          return  putApiV1UsersUserIdConversionReason(userId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1UsersUserIdConversionReasonMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1UsersUserIdConversionReason>>>
    export type PutApiV1UsersUserIdConversionReasonMutationBody = PutUserConversionReasonRequestBody | null
    export type PutApiV1UsersUserIdConversionReasonMutationError = HttpValidationProblemDetails | null | ProblemDetails

    export const usePutApiV1UsersUserIdConversionReason = <TError = HttpValidationProblemDetails | null | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1UsersUserIdConversionReason>>, TError,{userId: number;data: PutUserConversionReasonRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1UsersUserIdConversionReason>>,
        TError,
        {userId: number;data: PutUserConversionReasonRequestBody | null},
        TContext
      > => {
      return useMutation(getPutApiV1UsersUserIdConversionReasonMutationOptions(options), queryClient);
    }
    export const putApiV1UsersUserIdRegistrationQuestionQuestionId = (
    userId: number,
    questionId: number,
    putUserRegistrationQuestionAnswerRequestBodyNull: PutUserRegistrationQuestionAnswerRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/users/${userId}/registration-question/${questionId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserRegistrationQuestionAnswerRequestBodyNull, signal
    },
      );
    }




export const getPutApiV1UsersUserIdRegistrationQuestionQuestionIdMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1UsersUserIdRegistrationQuestionQuestionId>>, TError,{userId: number;questionId: number;data: PutUserRegistrationQuestionAnswerRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1UsersUserIdRegistrationQuestionQuestionId>>, TError,{userId: number;questionId: number;data: PutUserRegistrationQuestionAnswerRequestBody | null}, TContext> => {

const mutationKey = ['putApiV1UsersUserIdRegistrationQuestionQuestionId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1UsersUserIdRegistrationQuestionQuestionId>>, {userId: number;questionId: number;data: PutUserRegistrationQuestionAnswerRequestBody | null}> = (props) => {
          const {userId,questionId,data} = props ?? {};

          return  putApiV1UsersUserIdRegistrationQuestionQuestionId(userId,questionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1UsersUserIdRegistrationQuestionQuestionIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1UsersUserIdRegistrationQuestionQuestionId>>>
    export type PutApiV1UsersUserIdRegistrationQuestionQuestionIdMutationBody = PutUserRegistrationQuestionAnswerRequestBody | null
    export type PutApiV1UsersUserIdRegistrationQuestionQuestionIdMutationError = ProblemDetails | null

    export const usePutApiV1UsersUserIdRegistrationQuestionQuestionId = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1UsersUserIdRegistrationQuestionQuestionId>>, TError,{userId: number;questionId: number;data: PutUserRegistrationQuestionAnswerRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1UsersUserIdRegistrationQuestionQuestionId>>,
        TError,
        {userId: number;questionId: number;data: PutUserRegistrationQuestionAnswerRequestBody | null},
        TContext
      > => {
      return useMutation(getPutApiV1UsersUserIdRegistrationQuestionQuestionIdMutationOptions(options), queryClient);
    }
    export const getApiV1UsersUserIdMusicUsageLogs = (
    userId: number,
    params: GetApiV1UsersUserIdMusicUsageLogsParams,
 signal?: AbortSignal
) => {


      return apiClient<GetUserMusicUsageLogsResponse | null>(
      {url: `/api/v1/users/${userId}/music-usage-logs`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1UsersUserIdMusicUsageLogsQueryKey = (userId: number,
    params?: GetApiV1UsersUserIdMusicUsageLogsParams,) => {
    return [
    `/api/v1/users/${userId}/music-usage-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1UsersUserIdMusicUsageLogsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1UsersUserIdMusicUsageLogs>>, TError = ProblemDetails | null>(userId: number,
    params: GetApiV1UsersUserIdMusicUsageLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdMusicUsageLogs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1UsersUserIdMusicUsageLogsQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1UsersUserIdMusicUsageLogs>>> = ({ signal }) => getApiV1UsersUserIdMusicUsageLogs(userId,params, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdMusicUsageLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1UsersUserIdMusicUsageLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1UsersUserIdMusicUsageLogs>>>
export type GetApiV1UsersUserIdMusicUsageLogsQueryError = ProblemDetails | null


export function useGetApiV1UsersUserIdMusicUsageLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdMusicUsageLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdMusicUsageLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdMusicUsageLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdMusicUsageLogs>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdMusicUsageLogs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdMusicUsageLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdMusicUsageLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdMusicUsageLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdMusicUsageLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdMusicUsageLogs>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdMusicUsageLogs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdMusicUsageLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdMusicUsageLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdMusicUsageLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdMusicUsageLogs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1UsersUserIdMusicUsageLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdMusicUsageLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdMusicUsageLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdMusicUsageLogs>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1UsersUserIdMusicUsageLogsQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1UsersUserIdArtistDownloadStats = (
    userId: number,
    params: GetApiV1UsersUserIdArtistDownloadStatsParams,
 signal?: AbortSignal
) => {


      return apiClient<GetUserArtistDownloadStatsResponse | null>(
      {url: `/api/v1/users/${userId}/artist-download-stats`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1UsersUserIdArtistDownloadStatsQueryKey = (userId: number,
    params?: GetApiV1UsersUserIdArtistDownloadStatsParams,) => {
    return [
    `/api/v1/users/${userId}/artist-download-stats`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1UsersUserIdArtistDownloadStatsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1UsersUserIdArtistDownloadStats>>, TError = HttpValidationProblemDetails | null | ProblemDetails>(userId: number,
    params: GetApiV1UsersUserIdArtistDownloadStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdArtistDownloadStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1UsersUserIdArtistDownloadStatsQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1UsersUserIdArtistDownloadStats>>> = ({ signal }) => getApiV1UsersUserIdArtistDownloadStats(userId,params, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdArtistDownloadStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1UsersUserIdArtistDownloadStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1UsersUserIdArtistDownloadStats>>>
export type GetApiV1UsersUserIdArtistDownloadStatsQueryError = HttpValidationProblemDetails | null | ProblemDetails


export function useGetApiV1UsersUserIdArtistDownloadStats<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdArtistDownloadStats>>, TError = HttpValidationProblemDetails | null | ProblemDetails>(
 userId: number,
    params: GetApiV1UsersUserIdArtistDownloadStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdArtistDownloadStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdArtistDownloadStats>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdArtistDownloadStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdArtistDownloadStats<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdArtistDownloadStats>>, TError = HttpValidationProblemDetails | null | ProblemDetails>(
 userId: number,
    params: GetApiV1UsersUserIdArtistDownloadStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdArtistDownloadStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdArtistDownloadStats>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdArtistDownloadStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdArtistDownloadStats<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdArtistDownloadStats>>, TError = HttpValidationProblemDetails | null | ProblemDetails>(
 userId: number,
    params: GetApiV1UsersUserIdArtistDownloadStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdArtistDownloadStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1UsersUserIdArtistDownloadStats<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdArtistDownloadStats>>, TError = HttpValidationProblemDetails | null | ProblemDetails>(
 userId: number,
    params: GetApiV1UsersUserIdArtistDownloadStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdArtistDownloadStats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1UsersUserIdArtistDownloadStatsQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiV1UsersUserIdSubscriptionLicensesLicenseIdLicenseCode = (
    userId: number,
    licenseId: string | null,
 signal?: AbortSignal
) => {


      return apiClient<PostUserLicenseCodeResponse | null>(
      {url: `/api/v1/users/${userId}/subscription-licenses/${licenseId}/license-code`, method: 'POST', signal
    },
      );
    }




export const getPostApiV1UsersUserIdSubscriptionLicensesLicenseIdLicenseCodeMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UsersUserIdSubscriptionLicensesLicenseIdLicenseCode>>, TError,{userId: number;licenseId: string | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1UsersUserIdSubscriptionLicensesLicenseIdLicenseCode>>, TError,{userId: number;licenseId: string | null}, TContext> => {

const mutationKey = ['postApiV1UsersUserIdSubscriptionLicensesLicenseIdLicenseCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1UsersUserIdSubscriptionLicensesLicenseIdLicenseCode>>, {userId: number;licenseId: string | null}> = (props) => {
          const {userId,licenseId} = props ?? {};

          return  postApiV1UsersUserIdSubscriptionLicensesLicenseIdLicenseCode(userId,licenseId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1UsersUserIdSubscriptionLicensesLicenseIdLicenseCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1UsersUserIdSubscriptionLicensesLicenseIdLicenseCode>>>

    export type PostApiV1UsersUserIdSubscriptionLicensesLicenseIdLicenseCodeMutationError = ProblemDetails | null

    export const usePostApiV1UsersUserIdSubscriptionLicensesLicenseIdLicenseCode = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UsersUserIdSubscriptionLicensesLicenseIdLicenseCode>>, TError,{userId: number;licenseId: string | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1UsersUserIdSubscriptionLicensesLicenseIdLicenseCode>>,
        TError,
        {userId: number;licenseId: string | null},
        TContext
      > => {
      return useMutation(getPostApiV1UsersUserIdSubscriptionLicensesLicenseIdLicenseCodeMutationOptions(options), queryClient);
    }
    export const putApiV1UsersUserIdEmail = (
    userId: number,
    putUserEmailRequestBodyNull: PutUserEmailRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/users/${userId}/email`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserEmailRequestBodyNull, signal
    },
      );
    }




export const getPutApiV1UsersUserIdEmailMutationOptions = <TError = HttpValidationProblemDetails | null | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1UsersUserIdEmail>>, TError,{userId: number;data: PutUserEmailRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1UsersUserIdEmail>>, TError,{userId: number;data: PutUserEmailRequestBody | null}, TContext> => {

const mutationKey = ['putApiV1UsersUserIdEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1UsersUserIdEmail>>, {userId: number;data: PutUserEmailRequestBody | null}> = (props) => {
          const {userId,data} = props ?? {};

          return  putApiV1UsersUserIdEmail(userId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1UsersUserIdEmailMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1UsersUserIdEmail>>>
    export type PutApiV1UsersUserIdEmailMutationBody = PutUserEmailRequestBody | null
    export type PutApiV1UsersUserIdEmailMutationError = HttpValidationProblemDetails | null | ProblemDetails

    export const usePutApiV1UsersUserIdEmail = <TError = HttpValidationProblemDetails | null | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1UsersUserIdEmail>>, TError,{userId: number;data: PutUserEmailRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1UsersUserIdEmail>>,
        TError,
        {userId: number;data: PutUserEmailRequestBody | null},
        TContext
      > => {
      return useMutation(getPutApiV1UsersUserIdEmailMutationOptions(options), queryClient);
    }
    export const getApiV1UsersUserIdCarouselsJumpBackIn = (
    userId: number,
    params?: GetApiV1UsersUserIdCarouselsJumpBackInParams,
 signal?: AbortSignal
) => {


      return apiClient<GetUserJumpBackInCarouselResponse | null>(
      {url: `/api/v1/users/${userId}/carousels/jump-back-in`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1UsersUserIdCarouselsJumpBackInQueryKey = (userId: number,
    params?: GetApiV1UsersUserIdCarouselsJumpBackInParams,) => {
    return [
    `/api/v1/users/${userId}/carousels/jump-back-in`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1UsersUserIdCarouselsJumpBackInQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsJumpBackIn>>, TError = HttpValidationProblemDetails | null | ProblemDetails>(userId: number,
    params?: GetApiV1UsersUserIdCarouselsJumpBackInParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsJumpBackIn>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1UsersUserIdCarouselsJumpBackInQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsJumpBackIn>>> = ({ signal }) => getApiV1UsersUserIdCarouselsJumpBackIn(userId,params, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsJumpBackIn>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1UsersUserIdCarouselsJumpBackInQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsJumpBackIn>>>
export type GetApiV1UsersUserIdCarouselsJumpBackInQueryError = HttpValidationProblemDetails | null | ProblemDetails


export function useGetApiV1UsersUserIdCarouselsJumpBackIn<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsJumpBackIn>>, TError = HttpValidationProblemDetails | null | ProblemDetails>(
 userId: number,
    params: undefined |  GetApiV1UsersUserIdCarouselsJumpBackInParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsJumpBackIn>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsJumpBackIn>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsJumpBackIn>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdCarouselsJumpBackIn<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsJumpBackIn>>, TError = HttpValidationProblemDetails | null | ProblemDetails>(
 userId: number,
    params?: GetApiV1UsersUserIdCarouselsJumpBackInParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsJumpBackIn>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsJumpBackIn>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsJumpBackIn>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdCarouselsJumpBackIn<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsJumpBackIn>>, TError = HttpValidationProblemDetails | null | ProblemDetails>(
 userId: number,
    params?: GetApiV1UsersUserIdCarouselsJumpBackInParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsJumpBackIn>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1UsersUserIdCarouselsJumpBackIn<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsJumpBackIn>>, TError = HttpValidationProblemDetails | null | ProblemDetails>(
 userId: number,
    params?: GetApiV1UsersUserIdCarouselsJumpBackInParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsJumpBackIn>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1UsersUserIdCarouselsJumpBackInQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1UsersUserIdCarouselsRecentDownloads = (
    userId: number,
    params?: GetApiV1UsersUserIdCarouselsRecentDownloadsParams,
 signal?: AbortSignal
) => {


      return apiClient<GetUserRecentDownloadsCarouselResponse | null>(
      {url: `/api/v1/users/${userId}/carousels/recent-downloads`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1UsersUserIdCarouselsRecentDownloadsQueryKey = (userId: number,
    params?: GetApiV1UsersUserIdCarouselsRecentDownloadsParams,) => {
    return [
    `/api/v1/users/${userId}/carousels/recent-downloads`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1UsersUserIdCarouselsRecentDownloadsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsRecentDownloads>>, TError = HttpValidationProblemDetails | null | ProblemDetails>(userId: number,
    params?: GetApiV1UsersUserIdCarouselsRecentDownloadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsRecentDownloads>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1UsersUserIdCarouselsRecentDownloadsQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsRecentDownloads>>> = ({ signal }) => getApiV1UsersUserIdCarouselsRecentDownloads(userId,params, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsRecentDownloads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1UsersUserIdCarouselsRecentDownloadsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsRecentDownloads>>>
export type GetApiV1UsersUserIdCarouselsRecentDownloadsQueryError = HttpValidationProblemDetails | null | ProblemDetails


export function useGetApiV1UsersUserIdCarouselsRecentDownloads<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsRecentDownloads>>, TError = HttpValidationProblemDetails | null | ProblemDetails>(
 userId: number,
    params: undefined |  GetApiV1UsersUserIdCarouselsRecentDownloadsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsRecentDownloads>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsRecentDownloads>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsRecentDownloads>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdCarouselsRecentDownloads<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsRecentDownloads>>, TError = HttpValidationProblemDetails | null | ProblemDetails>(
 userId: number,
    params?: GetApiV1UsersUserIdCarouselsRecentDownloadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsRecentDownloads>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsRecentDownloads>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsRecentDownloads>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdCarouselsRecentDownloads<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsRecentDownloads>>, TError = HttpValidationProblemDetails | null | ProblemDetails>(
 userId: number,
    params?: GetApiV1UsersUserIdCarouselsRecentDownloadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsRecentDownloads>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1UsersUserIdCarouselsRecentDownloads<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsRecentDownloads>>, TError = HttpValidationProblemDetails | null | ProblemDetails>(
 userId: number,
    params?: GetApiV1UsersUserIdCarouselsRecentDownloadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCarouselsRecentDownloads>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1UsersUserIdCarouselsRecentDownloadsQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1UsersUserIdSfxUsageLogs = (
    userId: number,
    params: GetApiV1UsersUserIdSfxUsageLogsParams,
 signal?: AbortSignal
) => {


      return apiClient<GetUserSfxUsageLogsResponse | null>(
      {url: `/api/v1/users/${userId}/sfx-usage-logs`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1UsersUserIdSfxUsageLogsQueryKey = (userId: number,
    params?: GetApiV1UsersUserIdSfxUsageLogsParams,) => {
    return [
    `/api/v1/users/${userId}/sfx-usage-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1UsersUserIdSfxUsageLogsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1UsersUserIdSfxUsageLogs>>, TError = ProblemDetails | null>(userId: number,
    params: GetApiV1UsersUserIdSfxUsageLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdSfxUsageLogs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1UsersUserIdSfxUsageLogsQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1UsersUserIdSfxUsageLogs>>> = ({ signal }) => getApiV1UsersUserIdSfxUsageLogs(userId,params, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdSfxUsageLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1UsersUserIdSfxUsageLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1UsersUserIdSfxUsageLogs>>>
export type GetApiV1UsersUserIdSfxUsageLogsQueryError = ProblemDetails | null


export function useGetApiV1UsersUserIdSfxUsageLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdSfxUsageLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdSfxUsageLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdSfxUsageLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdSfxUsageLogs>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdSfxUsageLogs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdSfxUsageLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdSfxUsageLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdSfxUsageLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdSfxUsageLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdSfxUsageLogs>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdSfxUsageLogs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdSfxUsageLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdSfxUsageLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdSfxUsageLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdSfxUsageLogs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1UsersUserIdSfxUsageLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdSfxUsageLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdSfxUsageLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdSfxUsageLogs>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1UsersUserIdSfxUsageLogsQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1UsersUserIdMgUsageLogs = (
    userId: number,
    params: GetApiV1UsersUserIdMgUsageLogsParams,
 signal?: AbortSignal
) => {


      return apiClient<GetUserMgUsageLogsResponse | null>(
      {url: `/api/v1/users/${userId}/mg-usage-logs`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1UsersUserIdMgUsageLogsQueryKey = (userId: number,
    params?: GetApiV1UsersUserIdMgUsageLogsParams,) => {
    return [
    `/api/v1/users/${userId}/mg-usage-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1UsersUserIdMgUsageLogsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1UsersUserIdMgUsageLogs>>, TError = ProblemDetails | null>(userId: number,
    params: GetApiV1UsersUserIdMgUsageLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdMgUsageLogs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1UsersUserIdMgUsageLogsQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1UsersUserIdMgUsageLogs>>> = ({ signal }) => getApiV1UsersUserIdMgUsageLogs(userId,params, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdMgUsageLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1UsersUserIdMgUsageLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1UsersUserIdMgUsageLogs>>>
export type GetApiV1UsersUserIdMgUsageLogsQueryError = ProblemDetails | null


export function useGetApiV1UsersUserIdMgUsageLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdMgUsageLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdMgUsageLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdMgUsageLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdMgUsageLogs>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdMgUsageLogs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdMgUsageLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdMgUsageLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdMgUsageLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdMgUsageLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdMgUsageLogs>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdMgUsageLogs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdMgUsageLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdMgUsageLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdMgUsageLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdMgUsageLogs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1UsersUserIdMgUsageLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdMgUsageLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdMgUsageLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdMgUsageLogs>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1UsersUserIdMgUsageLogsQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1UsersUserIdVideoUsageLogs = (
    userId: number,
    params: GetApiV1UsersUserIdVideoUsageLogsParams,
 signal?: AbortSignal
) => {


      return apiClient<GetUserVideoUsageLogsResponse | null>(
      {url: `/api/v1/users/${userId}/video-usage-logs`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1UsersUserIdVideoUsageLogsQueryKey = (userId: number,
    params?: GetApiV1UsersUserIdVideoUsageLogsParams,) => {
    return [
    `/api/v1/users/${userId}/video-usage-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1UsersUserIdVideoUsageLogsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1UsersUserIdVideoUsageLogs>>, TError = ProblemDetails | null>(userId: number,
    params: GetApiV1UsersUserIdVideoUsageLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdVideoUsageLogs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1UsersUserIdVideoUsageLogsQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1UsersUserIdVideoUsageLogs>>> = ({ signal }) => getApiV1UsersUserIdVideoUsageLogs(userId,params, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdVideoUsageLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1UsersUserIdVideoUsageLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1UsersUserIdVideoUsageLogs>>>
export type GetApiV1UsersUserIdVideoUsageLogsQueryError = ProblemDetails | null


export function useGetApiV1UsersUserIdVideoUsageLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdVideoUsageLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdVideoUsageLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdVideoUsageLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdVideoUsageLogs>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdVideoUsageLogs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdVideoUsageLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdVideoUsageLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdVideoUsageLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdVideoUsageLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdVideoUsageLogs>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdVideoUsageLogs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdVideoUsageLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdVideoUsageLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdVideoUsageLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdVideoUsageLogs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1UsersUserIdVideoUsageLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdVideoUsageLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdVideoUsageLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdVideoUsageLogs>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1UsersUserIdVideoUsageLogsQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1UsersUserIdCustomerSubPlans = (
    userId: number,
    params: GetApiV1UsersUserIdCustomerSubPlansParams,
 signal?: AbortSignal
) => {


      return apiClient<GetUserCustomerSubPlansResponse | null>(
      {url: `/api/v1/users/${userId}/customer-sub-plans`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1UsersUserIdCustomerSubPlansQueryKey = (userId: number,
    params?: GetApiV1UsersUserIdCustomerSubPlansParams,) => {
    return [
    `/api/v1/users/${userId}/customer-sub-plans`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1UsersUserIdCustomerSubPlansQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlans>>, TError = ProblemDetails | null>(userId: number,
    params: GetApiV1UsersUserIdCustomerSubPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlans>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1UsersUserIdCustomerSubPlansQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlans>>> = ({ signal }) => getApiV1UsersUserIdCustomerSubPlans(userId,params, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1UsersUserIdCustomerSubPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlans>>>
export type GetApiV1UsersUserIdCustomerSubPlansQueryError = ProblemDetails | null


export function useGetApiV1UsersUserIdCustomerSubPlans<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlans>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdCustomerSubPlansParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlans>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlans>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdCustomerSubPlans<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlans>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdCustomerSubPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlans>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlans>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdCustomerSubPlans<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlans>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdCustomerSubPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlans>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1UsersUserIdCustomerSubPlans<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlans>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdCustomerSubPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlans>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1UsersUserIdCustomerSubPlansQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1UsersUserIdCustomerSubPlansCurrent = (
    userId: number,
 signal?: AbortSignal
) => {


      return apiClient<CustomerSubPlanItem | null>(
      {url: `/api/v1/users/${userId}/customer-sub-plans/current`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1UsersUserIdCustomerSubPlansCurrentQueryKey = (userId: number,) => {
    return [
    `/api/v1/users/${userId}/customer-sub-plans/current`
    ] as const;
    }


export const getGetApiV1UsersUserIdCustomerSubPlansCurrentQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlansCurrent>>, TError = ProblemDetails | null>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlansCurrent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1UsersUserIdCustomerSubPlansCurrentQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlansCurrent>>> = ({ signal }) => getApiV1UsersUserIdCustomerSubPlansCurrent(userId, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlansCurrent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1UsersUserIdCustomerSubPlansCurrentQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlansCurrent>>>
export type GetApiV1UsersUserIdCustomerSubPlansCurrentQueryError = ProblemDetails | null


export function useGetApiV1UsersUserIdCustomerSubPlansCurrent<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlansCurrent>>, TError = ProblemDetails | null>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlansCurrent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlansCurrent>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlansCurrent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdCustomerSubPlansCurrent<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlansCurrent>>, TError = ProblemDetails | null>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlansCurrent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlansCurrent>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlansCurrent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdCustomerSubPlansCurrent<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlansCurrent>>, TError = ProblemDetails | null>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlansCurrent>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1UsersUserIdCustomerSubPlansCurrent<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlansCurrent>>, TError = ProblemDetails | null>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdCustomerSubPlansCurrent>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1UsersUserIdCustomerSubPlansCurrentQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1UsersUserIdPermissions = (
    userId: number,
 signal?: AbortSignal
) => {


      return apiClient<GetUserPermissionsResponse | null>(
      {url: `/api/v1/users/${userId}/permissions`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1UsersUserIdPermissionsQueryKey = (userId: number,) => {
    return [
    `/api/v1/users/${userId}/permissions`
    ] as const;
    }


export const getGetApiV1UsersUserIdPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1UsersUserIdPermissions>>, TError = ProblemDetails | null>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdPermissions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1UsersUserIdPermissionsQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1UsersUserIdPermissions>>> = ({ signal }) => getApiV1UsersUserIdPermissions(userId, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1UsersUserIdPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1UsersUserIdPermissions>>>
export type GetApiV1UsersUserIdPermissionsQueryError = ProblemDetails | null


export function useGetApiV1UsersUserIdPermissions<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdPermissions>>, TError = ProblemDetails | null>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdPermissions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdPermissions<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdPermissions>>, TError = ProblemDetails | null>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdPermissions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdPermissions<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdPermissions>>, TError = ProblemDetails | null>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdPermissions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1UsersUserIdPermissions<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdPermissions>>, TError = ProblemDetails | null>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdPermissions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1UsersUserIdPermissionsQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1UsersUserIdMetaEventLogs = (
    userId: number,
    params: GetApiV1UsersUserIdMetaEventLogsParams,
 signal?: AbortSignal
) => {


      return apiClient<GetUserMetaEventLogsResponse | null>(
      {url: `/api/v1/users/${userId}/meta-event-logs`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1UsersUserIdMetaEventLogsQueryKey = (userId: number,
    params?: GetApiV1UsersUserIdMetaEventLogsParams,) => {
    return [
    `/api/v1/users/${userId}/meta-event-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1UsersUserIdMetaEventLogsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1UsersUserIdMetaEventLogs>>, TError = ProblemDetails | null>(userId: number,
    params: GetApiV1UsersUserIdMetaEventLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdMetaEventLogs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1UsersUserIdMetaEventLogsQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1UsersUserIdMetaEventLogs>>> = ({ signal }) => getApiV1UsersUserIdMetaEventLogs(userId,params, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdMetaEventLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1UsersUserIdMetaEventLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1UsersUserIdMetaEventLogs>>>
export type GetApiV1UsersUserIdMetaEventLogsQueryError = ProblemDetails | null


export function useGetApiV1UsersUserIdMetaEventLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdMetaEventLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdMetaEventLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdMetaEventLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdMetaEventLogs>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdMetaEventLogs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdMetaEventLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdMetaEventLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdMetaEventLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdMetaEventLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserIdMetaEventLogs>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserIdMetaEventLogs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserIdMetaEventLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdMetaEventLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdMetaEventLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdMetaEventLogs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1UsersUserIdMetaEventLogs<TData = Awaited<ReturnType<typeof getApiV1UsersUserIdMetaEventLogs>>, TError = ProblemDetails | null>(
 userId: number,
    params: GetApiV1UsersUserIdMetaEventLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserIdMetaEventLogs>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1UsersUserIdMetaEventLogsQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1UsersUserId = (
    userId: number,
 signal?: AbortSignal
) => {


      return apiClient<GetUserResponse | null>(
      {url: `/api/v1/users/${userId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1UsersUserIdQueryKey = (userId: number,) => {
    return [
    `/api/v1/users/${userId}`
    ] as const;
    }


export const getGetApiV1UsersUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1UsersUserId>>, TError = ProblemDetails | null>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1UsersUserIdQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1UsersUserId>>> = ({ signal }) => getApiV1UsersUserId(userId, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1UsersUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1UsersUserId>>>
export type GetApiV1UsersUserIdQueryError = ProblemDetails | null


export function useGetApiV1UsersUserId<TData = Awaited<ReturnType<typeof getApiV1UsersUserId>>, TError = ProblemDetails | null>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserId<TData = Awaited<ReturnType<typeof getApiV1UsersUserId>>, TError = ProblemDetails | null>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UsersUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UsersUserId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UsersUserId<TData = Awaited<ReturnType<typeof getApiV1UsersUserId>>, TError = ProblemDetails | null>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1UsersUserId<TData = Awaited<ReturnType<typeof getApiV1UsersUserId>>, TError = ProblemDetails | null>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UsersUserId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1UsersUserIdQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiV1UsersUserId = (
    userId: number,
    patchUserRequestBodyNull: PatchUserRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/users/${userId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchUserRequestBodyNull, signal
    },
      );
    }




export const getPatchApiV1UsersUserIdMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1UsersUserId>>, TError,{userId: number;data: PatchUserRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiV1UsersUserId>>, TError,{userId: number;data: PatchUserRequestBody | null}, TContext> => {

const mutationKey = ['patchApiV1UsersUserId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiV1UsersUserId>>, {userId: number;data: PatchUserRequestBody | null}> = (props) => {
          const {userId,data} = props ?? {};

          return  patchApiV1UsersUserId(userId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiV1UsersUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1UsersUserId>>>
    export type PatchApiV1UsersUserIdMutationBody = PatchUserRequestBody | null
    export type PatchApiV1UsersUserIdMutationError = ProblemDetails | null

    export const usePatchApiV1UsersUserId = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1UsersUserId>>, TError,{userId: number;data: PatchUserRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiV1UsersUserId>>,
        TError,
        {userId: number;data: PatchUserRequestBody | null},
        TContext
      > => {
      return useMutation(getPatchApiV1UsersUserIdMutationOptions(options), queryClient);
    }
    export const deleteApiV1UsersUserId = (
    userId: number,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/users/${userId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiV1UsersUserIdMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1UsersUserId>>, TError,{userId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1UsersUserId>>, TError,{userId: number}, TContext> => {

const mutationKey = ['deleteApiV1UsersUserId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiV1UsersUserId>>, {userId: number}> = (props) => {
          const {userId} = props ?? {};

          return  deleteApiV1UsersUserId(userId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiV1UsersUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1UsersUserId>>>

    export type DeleteApiV1UsersUserIdMutationError = ProblemDetails | null

    export const useDeleteApiV1UsersUserId = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1UsersUserId>>, TError,{userId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiV1UsersUserId>>,
        TError,
        {userId: number},
        TContext
      > => {
      return useMutation(getDeleteApiV1UsersUserIdMutationOptions(options), queryClient);
    }
    export const deleteApiV1UsersUserIdCode = (
    userId: number,
    code: number | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/users/${userId}/${code}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiV1UsersUserIdCodeMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1UsersUserIdCode>>, TError,{userId: number;code: number | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1UsersUserIdCode>>, TError,{userId: number;code: number | null}, TContext> => {

const mutationKey = ['deleteApiV1UsersUserIdCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiV1UsersUserIdCode>>, {userId: number;code: number | null}> = (props) => {
          const {userId,code} = props ?? {};

          return  deleteApiV1UsersUserIdCode(userId,code,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiV1UsersUserIdCodeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1UsersUserIdCode>>>

    export type DeleteApiV1UsersUserIdCodeMutationError = ProblemDetails | null

    export const useDeleteApiV1UsersUserIdCode = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1UsersUserIdCode>>, TError,{userId: number;code: number | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiV1UsersUserIdCode>>,
        TError,
        {userId: number;code: number | null},
        TContext
      > => {
      return useMutation(getDeleteApiV1UsersUserIdCodeMutationOptions(options), queryClient);
    }
    export const postApiV1UsersUserIdCodeValidate = (
    userId: number,
    code: number,
 signal?: AbortSignal
) => {


      return apiClient<ValidateAccountDeletionCodeResponse | null>(
      {url: `/api/v1/users/${userId}/${code}/validate`, method: 'POST', signal
    },
      );
    }




export const getPostApiV1UsersUserIdCodeValidateMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UsersUserIdCodeValidate>>, TError,{userId: number;code: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1UsersUserIdCodeValidate>>, TError,{userId: number;code: number}, TContext> => {

const mutationKey = ['postApiV1UsersUserIdCodeValidate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1UsersUserIdCodeValidate>>, {userId: number;code: number}> = (props) => {
          const {userId,code} = props ?? {};

          return  postApiV1UsersUserIdCodeValidate(userId,code,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1UsersUserIdCodeValidateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1UsersUserIdCodeValidate>>>

    export type PostApiV1UsersUserIdCodeValidateMutationError = ProblemDetails | null

    export const usePostApiV1UsersUserIdCodeValidate = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UsersUserIdCodeValidate>>, TError,{userId: number;code: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1UsersUserIdCodeValidate>>,
        TError,
        {userId: number;code: number},
        TContext
      > => {
      return useMutation(getPostApiV1UsersUserIdCodeValidateMutationOptions(options), queryClient);
    }
    export const postApiV1UsersUserIdPermissionOverridesPermissionId = (
    userId: number,
    permissionId: number,
    params: PostApiV1UsersUserIdPermissionOverridesPermissionIdParams,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/users/${userId}/permission-overrides/${permissionId}`, method: 'POST',
        params, signal
    },
      );
    }




export const getPostApiV1UsersUserIdPermissionOverridesPermissionIdMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UsersUserIdPermissionOverridesPermissionId>>, TError,{userId: number;permissionId: number;params: PostApiV1UsersUserIdPermissionOverridesPermissionIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1UsersUserIdPermissionOverridesPermissionId>>, TError,{userId: number;permissionId: number;params: PostApiV1UsersUserIdPermissionOverridesPermissionIdParams}, TContext> => {

const mutationKey = ['postApiV1UsersUserIdPermissionOverridesPermissionId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1UsersUserIdPermissionOverridesPermissionId>>, {userId: number;permissionId: number;params: PostApiV1UsersUserIdPermissionOverridesPermissionIdParams}> = (props) => {
          const {userId,permissionId,params} = props ?? {};

          return  postApiV1UsersUserIdPermissionOverridesPermissionId(userId,permissionId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1UsersUserIdPermissionOverridesPermissionIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1UsersUserIdPermissionOverridesPermissionId>>>

    export type PostApiV1UsersUserIdPermissionOverridesPermissionIdMutationError = ProblemDetails | null

    export const usePostApiV1UsersUserIdPermissionOverridesPermissionId = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UsersUserIdPermissionOverridesPermissionId>>, TError,{userId: number;permissionId: number;params: PostApiV1UsersUserIdPermissionOverridesPermissionIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1UsersUserIdPermissionOverridesPermissionId>>,
        TError,
        {userId: number;permissionId: number;params: PostApiV1UsersUserIdPermissionOverridesPermissionIdParams},
        TContext
      > => {
      return useMutation(getPostApiV1UsersUserIdPermissionOverridesPermissionIdMutationOptions(options), queryClient);
    }
    export const deleteApiV1UsersUserIdPermissionOverridesPermissionId = (
    userId: number,
    permissionId: number,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/users/${userId}/permission-overrides/${permissionId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiV1UsersUserIdPermissionOverridesPermissionIdMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1UsersUserIdPermissionOverridesPermissionId>>, TError,{userId: number;permissionId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1UsersUserIdPermissionOverridesPermissionId>>, TError,{userId: number;permissionId: number}, TContext> => {

const mutationKey = ['deleteApiV1UsersUserIdPermissionOverridesPermissionId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiV1UsersUserIdPermissionOverridesPermissionId>>, {userId: number;permissionId: number}> = (props) => {
          const {userId,permissionId} = props ?? {};

          return  deleteApiV1UsersUserIdPermissionOverridesPermissionId(userId,permissionId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiV1UsersUserIdPermissionOverridesPermissionIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1UsersUserIdPermissionOverridesPermissionId>>>

    export type DeleteApiV1UsersUserIdPermissionOverridesPermissionIdMutationError = ProblemDetails | null

    export const useDeleteApiV1UsersUserIdPermissionOverridesPermissionId = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1UsersUserIdPermissionOverridesPermissionId>>, TError,{userId: number;permissionId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiV1UsersUserIdPermissionOverridesPermissionId>>,
        TError,
        {userId: number;permissionId: number},
        TContext
      > => {
      return useMutation(getDeleteApiV1UsersUserIdPermissionOverridesPermissionIdMutationOptions(options), queryClient);
    }
